export interface RdsCdcWizardState {
  resourceId: string;
  format: 'aws-cli' | 'cloudformation' | 'terraform';
  ramResourceShareArn: string;
  selectedSecurityGroupId: string;
}

export const defaultRdsCdcWizardState: RdsCdcWizardState = {
  resourceId: '',
  format: 'aws-cli',
  ramResourceShareArn: '',
  selectedSecurityGroupId: '',
};
